(() => {
  const DESKTOP_QUERY = '(min-width: 992px)';
  const ITEMS_PER_PAGE = 3;

  const setActiveDot = (dots, activeIndex) => {
    dots.forEach((dot, index) => {
      const active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  const buildPageTargets = (scroller, items, dots) => {
    const maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);

    return dots.map((_, pageIndex) => {
      const itemIndex = Math.min(pageIndex * ITEMS_PER_PAGE, items.length - 1);
      const item = items[itemIndex];

      if (!item) {
        return 0;
      }

      return Math.max(0, Math.min(item.offsetLeft, maxScrollLeft));
    });
  };

  const getNearestPageIndex = (scrollLeft, pageTargets) => {
    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    pageTargets.forEach((target, index) => {
      const distance = Math.abs(scrollLeft - target);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  };

  const initSection = (root) => {
    if (!root || root.dataset.benefitsRowInit === 'true') {
      return;
    }
    root.dataset.benefitsRowInit = 'true';

    const scroller = root.querySelector('[data-benefits-row-scroller]');
    const items = Array.from(root.querySelectorAll('.benefits-row__item'));
    const dots = Array.from(root.querySelectorAll('[data-benefits-row-dot]'));

    if (!scroller || !items.length || !dots.length) {
      return;
    }

    let pageTargets = buildPageTargets(scroller, items, dots);
    let ticking = false;

    const syncDots = () => {
      if (window.matchMedia(DESKTOP_QUERY).matches) {
        setActiveDot(dots, 0);
        return;
      }

      if (!pageTargets.length) {
        pageTargets = buildPageTargets(scroller, items, dots);
      }

      const activeIndex = getNearestPageIndex(scroller.scrollLeft, pageTargets);
      setActiveDot(dots, activeIndex);
    };

    const syncDotsThrottled = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(() => {
        syncDots();
        ticking = false;
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        if (window.matchMedia(DESKTOP_QUERY).matches) {
          return;
        }

        const pageIndex = Number(dot.dataset.page || 0);
        const target = pageTargets[pageIndex];
        if (target == null) {
          return;
        }

        scroller.scrollTo({
          left: target,
          behavior: 'smooth'
        });
      });
    });

    scroller.addEventListener('scroll', syncDotsThrottled, { passive: true });
    window.addEventListener('resize', () => {
      pageTargets = buildPageTargets(scroller, items, dots);
      syncDots();
    });

    syncDots();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-benefits-row]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
